export default __webpack_public_path__ + "static/media/chat-overlay.4a6621a4.svg";